import {
    onClickPolylineCorrectionPointsSingleVoyage,
    onDragEndMarkerCorrectionPointsSingleVoyage,
    onRemoveMarkerCorrectionPointsSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/types/events";
import {
    closestIndexOfPolyline,
    toArrayLatLngPolyline
} from "@ui/leafletCustom/leafletPolyline/polylineDraggable/helpers";
import {
    createCorrectionWayPointByLatLng
} from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/helpers/createCorrectionWayPointByLatLng";
import {SetStatePropsType} from "@baseTypes/base";
import {ICorrectionWayPointSingleVoyage} from "@containers/singleVoyage/types/point";
import {useCallback} from "react";

export function useActionsCorrectionPointsMutateSingleVoyage({setTargetPoints}: {
    setTargetPoints: SetStatePropsType<ICorrectionWayPointSingleVoyage[]>
}): {
    onClickPolyline: onClickPolylineCorrectionPointsSingleVoyage,
    onRemoveMarker: onRemoveMarkerCorrectionPointsSingleVoyage,
    onDragEndMarker: onDragEndMarkerCorrectionPointsSingleVoyage,
} {
    const onDragEndMarker: onDragEndMarkerCorrectionPointsSingleVoyage = useCallback(({
                                                                                          point,
                                                                                          latLng,
                                                                                      }) => {
        const [lat, lng] = latLng
        setTargetPoints((prev) => {
            return prev?.map((oldPoint) => {
                if (point?.id === oldPoint?.id) {
                    return {
                        ...oldPoint,
                        lat,
                        lng
                    }
                }
                return oldPoint
            })
        })
    }, [])

    const onRemoveMarker: onRemoveMarkerCorrectionPointsSingleVoyage = useCallback((waypoint) => {
        setTargetPoints((prev) => prev.filter((point) => point.id !== waypoint.id))
    }, [])

    const onClickPolyline: onClickPolylineCorrectionPointsSingleVoyage = useCallback(({lat, lng}) => {
        const latLng = toArrayLatLngPolyline({lng, lat})
        setTargetPoints((prev) => {
            const fullLatLng = prev.map((point) => toArrayLatLngPolyline(point))
            const closestIndex = closestIndexOfPolyline(latLng, fullLatLng);
            const start = prev.slice(0, closestIndex + 1)
            const end = prev.slice(closestIndex + 1)
            return [
                ...start,
                createCorrectionWayPointByLatLng({
                    lat,
                    lng
                }),
                ...end
            ]
        })
    }, [])
    return {
        onClickPolyline,
        onRemoveMarker,
        onDragEndMarker,
    }
}